"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCUMULATION_BUCKET_EXPECTATIONS = void 0;
const unwrap_1 = require("../unwrap");
exports.ACCUMULATION_BUCKET_EXPECTATIONS = [
    // ── Michigan severely toxic hazardous waste ───────────────────────────
    {
        when: {
            state: "MI",
            stateWasteCodes: ["001S", "002S", "003S", "004S", "005S", "006S", "007S"],
        },
        expect: "ACUTE",
        citation: "Mich. Admin. Code R 299.9304, 299.9305(1)",
    },
    // ── Indiana chemical munitions ────────────────────────────────────────
    {
        when: { state: "IN", stateWasteCodes: ["I001"] },
        expect: "ACUTE",
        citation: "329 IAC 3.1-6-3(a)-(b)",
        note: (0, unwrap_1.unwrap) `
      Indiana adds the following specific wastes to be considered acutely haz. Regulation notes that they
      "have the Indiana hazardous waste number I001" (although the regs don't say that no OTHER wastes
      have this code - that is an ASSUMPTION).
      
      (1) GA (Ethyl-N, N-dimethyl phosphoramidocyanidate).
      
      (2) GB (Isopropyl methyl phosphonoflouridate).
      
      (3) H, HD (Bis(2-chloroethyl) sulfide).
      
      (4) HT (sixty percent (60%) HD and forty percent (40%) T (Bis[2(2-chloroethyl-thio)ethyl]ester)).
      
      (5) L (Dichloro(2-chlorovinyl)arsine).
      
      (6) VX (O-ethyl-S-(2-diisopropylaminoethyl) methyl phosphonothiolate).
      
      KNOWN GAP: 3.1-6-3(c) lets waste "derived from" (6) VX reach 55 gallons in a satellite area;
      VX carries the same I001 code, so it is held to the acute caps too (over-strict, never under-strict).
    `,
    },
    // baseline
    {
        when: { classification: "RCRA_ACUTELY_HAZARDOUS" },
        expect: "ACUTE",
    },
    {
        when: { classification: "RCRA_HAZARDOUS" },
        expect: "NON_ACUTE",
    },
    {
        when: { classification: "NONHAZARDOUS" },
        expect: "EXCLUDED",
    },
    // some inputs unknown; reasonable default
    {
        when: { state: null, classification: null },
        expect: "NON_ACUTE",
        note: "Waste that is not yet characterized is assumed to be hazardous, but not acutely so.",
    },
    // code smell - this is the current way the code works, but seems wrong that these are different
    {
        when: { classification: "STATE_REGULATED", whichThreshold: "SATELLITE_CAPS" },
        expect: "NON_ACUTE",
        note: (0, unwrap_1.unwrap) `
      KNOWN GAP: the fact that STATE_REGULATED behaves differently for satellite area caps
      and whole-facility on-site accumulation thresholds is a current weakness.
      Most likely more complex handling will be needed for STATE_REGULATED in general.
    `,
    },
    {
        when: { classification: "STATE_REGULATED", whichThreshold: "ON_SITE_THRESHOLD" },
        expect: "EXCLUDED",
        note: "See above.",
    },
];
//# sourceMappingURL=expectations.js.map